<template>
  <div>
    <DefaultLayout>
      <section class="color-data-table">
        <div class="breadcrumb">
          <template v-for="link in breadcrumb">
            <div
              class="img-route"
              :key="link.name"
            >
              <img
                src="../../src/assets/icons/leftArrow.svg"
                alt="arrow"
              />
              <router-link
                :to="link.link"
                :class="{ 'is-bold': validLinkName(link.name) }"
              >{{
              link.name
            }}</router-link>
            </div>
          </template>
        </div>
        <div class="container-payment-request">
          <div class="header-payment">
            <div class="title">
              <img
                :src="require('@/assets/icons/newPayment.svg')"
                alt="new-payment"
              />
              <h4>Payment Request</h4>
            </div>
          </div>
          <div class="inputs-request">
            <div class="label-input">
              <label for="company">Company name</label>
              <input
                autocomplete="off"
                id="company"
                v-model="company_name"
                class="inputs request"
                :class="{ 'error-input': validName && company_name === ''}"
                type="text"
                placeholder="Company Name"
              />
              <template v-if="validName && company_name ===''">
                <span class="error-msg">
                  Field required*</span>
              </template>
            </div>
            <div class="label-input">
              <label for="invoice-number">Invoice</label>
              <input
                autocomplete="off"
                id="invoice-number"
                v-mask="'NNNNNNNNNNNNNNN'"
                v-model="invoice_number"
                class="inputs request"
                :class="{ 'error-input': validNumber && invoice_number === ''}"
                type="text"
                placeholder="Invoice Number"
              />
              <template v-if="validNumber && invoice_number === ''">
                <span class="error-msg">
                  Field required*</span>
              </template>
            </div>
            <div class="label-input">
              <div class="calendar"></div>
              <label for="date">Transaction date</label>
              <vc-date-picker
                :class="{ 'error-input': validDateSelected || !transaction_date}"
                :masks="{ title: 'MM/DD/YYYY', input: 'MM/DD/YYYY' }"
                v-model="transaction_date"
                :input-props="{
                class: 'inputs request date'
              }"
              />
              <template v-if="validDateSelected || !transaction_date">
                <span class="error-msg">
                  Select today or after*</span>
              </template>
            </div>
            <div class="label-input">
              <label for="amount">Amount(USD)</label>
              <currency-input
                class="inputs
            request"
                :class="{ 'error-input': validAmount && amount <= 0.99 }"
                v-model="amount"
              />
              <template v-if="validAmount && amount <= 0.99">
                <span class="error-msg">
                  Minimum value is $1.00 USD*</span>
              </template>
            </div>
            <div class="comment-button">
              <div class="label-textarea">
                <label for="comment">Comments</label>
                <textarea
                  autocomplete="off"
                  id="comment"
                  v-model="comment"
                  class="inputs request-area"
                  :class="{ 'error-input': validComment && comment === '' }"
                  type="date"
                  placeholder="Comments"
                />
                <template v-if="validAmount && comment === ''">
                  <span class="error-msg">
                    Field required*</span>
                </template>
              </div>
              <div
                @click="valid()"
                class="align-button"
              >
                <button class="btn-transaction">Generate Link</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </DefaultLayout>
    <template v-if="modalWait">
      <ModalWait />
    </template>
    <template v-if="modalLink">
      <ModalLink
        :link="generatedLink"
        @closeModalLink="modalLink=$event"
      />
    </template>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ModalWait from '@/components/Modal/ModalWaitLink.vue';
import ModalLink from '@/components/Modal/ModalCopyLink.vue';
import Moment from 'moment';

export default {
  name: 'PaymentRequest',
  data() {
    return {
      breadcrumb: '',
      company_name: '',
      invoice_number: '',
      amount: 0,
      transaction_date: new Date(),
      comment: '',
      errorMessage: '',
      generatedLink: '',
      validName: false,
      validNumber: false,
      validAmount: false,
      validComment: false,
      validDateSelected: false,
      modalWait: false,
      modalLink: false,
    };
  },
  components: {
    DefaultLayout,
    ModalWait,
    ModalLink,
  },
  mounted() {
    this.getBreadcrumb();
  },
  watch: {
    transaction_date() {
      if (this.validDate()) {
        this.validDateSelected = true;
      } else {
        this.validDateSelected = false;
      }
    },
  },
  methods: {
    validDate() {
      const now = Moment(new Date()).format('MMDDYYYY');
      const isHigher = (Number(now) > Number(Moment(this.transaction_date).format('MMDDYYYY')));
      return isHigher;
    },
    async getBreadcrumb() {
      this.breadcrumb = this.$route.meta.breadcrumb;
    },
    validLinkName(link) {
      return link === 'Payment Request';
    },
    valid() {
      if (!this.company_name) {
        this.validName = true;
      }
      if (!this.invoice_number) {
        this.validNumber = true;
      }
      if (!this.amount || this.amount < 1) {
        this.validAmount = true;
      }
      if (!this.comment) {
        this.validComment = true;
      }
      if (
        this.company_name
        && this.invoice_number
        && this.amount > 0.99
        && !this.validDateSelected
        && this.comment
      ) {
        this.transaction_date = Moment(this.transaction_date).format('MM/DD/YYYY');
        this.generateLink();
      }
    },
    async generateLink() {
      this.modalWait = true;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.token}!`,
        },
        body: JSON.stringify({
          company_name: this.company_name,
          invoice_number: this.invoice_number,
          amount: this.amount,
          transaction_date: this.transaction_date,
          comment: this.comment,
        }),
      };
      fetch(`${process.env.VUE_APP_API_URL}/v1/transactions/store`, requestOptions)
        .then(async (response) => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.error) || response.status;
            this.modalWait = false;
            return Promise.reject(error);
          }
          this.generatedLink = `${process.env.VUE_APP_URL}/payment/${data.link}`;
          this.modalWait = false;
          this.modalLink = true;
          this.company_name = '';
          this.invoice_number = '';
          this.amount = 0;
          this.transaction_date = new Date();
          this.comment = '';
          this.validName = false;
          this.validNumber = false;
          this.validAmount = false;
          this.validDateSelected = false;
          this.validComment = false;
          return this.generatedLink;
        })
        .catch((error) => {
          this.modalWait = false;
          this.errorMessage = error;
        });
    },
  },
};
</script>
<style lang="scss">
.relative {
  position: relative;
  z-index: 1;
}
.container-payment-request {
  width: 69.2vw;
  background-color: $white;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  @media (max-width: 600px) {
    width: 100%;
  }
  .header-payment {
    padding-left: 29px;
    display: flex;
    align-items: center;
    height: 60px;
    border-bottom: 2px solid $backgroundData;
    @media (max-width: 600px) {
      padding-left: 15px;
    }
    .title {
      display: flex;
      img {
        margin-right: 20px;
        height: 24px;
        width: 24px;
      }
      h4 {
        font-weight: 600;
        font-size: 24px;
        color: $header;
      }
    }
  }
  .inputs-request {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0px 46px 18px 29px;
    @media (max-width: 600px) {
      padding: 0px 5px;
    }
    .label-input {
      position: relative;
      display: flex;
      flex-direction: column;
      text-align: left;
      label {
        font-weight: 500;
        font-size: 16.0015px;
        color: $header;
        margin-bottom: 5px;
        margin-top: 40px;
      }
    }
    .comment-button {
      display: flex;
      width: 100%;
      flex-direction: column;
      .label-textarea {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        text-align: left;
        margin-top: 20px;
        // @media (max-width: 600px) {
        //   width: 80vw;
        // }
        // textarea {
        //   width: 100%;
        //   height: 112px;
        // }
      }
      label {
        font-weight: 500;
        font-size: 16.0015px;
        color: $header;
        margin-bottom: 5px;
        margin-top: 40px;
      }
      .align-button {
        text-align: right;
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
  }
}
.breadcrumb {
  width: 69.2vw;
  margin: 0 auto;
  padding-top: 10px;
  display: flex;
  @media (max-width: 600px) {
    width: 95vw;
    margin-bottom: 10px !important;
    a {
      font-size: 16px !important;
    }
  }
  a {
    font-weight: 400;
    font-size: 17px;
    color: $header !important;
    &.is-bold {
      font-weight: 500;
      text-decoration: underline;
    }
  }
  .img-route {
    display: flex;
  }
}
.color-data-table {
  display: flex;
  position: relative;
  flex-direction: column;
  min-height: calc(100vh - 83px);
  background-color: $backgroundData;
  padding: 1rem;
  @media (max-width: 900px) {
    padding: 5px;
  }
}
.calendar {
  position: absolute;
  background-image: url("../../src/assets/icons/calendar.svg");
  width: 20px;
  height: 20px;
  margin-top: 77px;
  margin-left: 10px;
  z-index: 2;
}
</style>
